import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import fetchWrapper from "./../../../AuthMiddleware/FetchWrapper";

import "../../../assets/css/mainMenu.css";
import "../../../assets/css/addunit.css";

import edit from "../../../assets/icons/edit.svg";

import close from "../../../assets/icons/close.svg";

import recyclebin from "../../../assets/icons/recycle-bin2.svg";

import ArrowDown from "../../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../../assets/icons2/ArrowUp.svg";
import plus1 from "../../../assets/icons/plus1.svg";
import search2 from "../../../assets/icons/search2.svg";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../../Components/Pagination/Pagination";
import { hasPermission } from "../../../Services/authUtils";
// import { FaPlus, FaEdit, FaArrowDown, FaArrowUp } from "react-icons/fa";

const AssetAttribute = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [assetAttributes, setAssetAttributes] = useState([]);
  const [selectedAssetAttribute, setSelectedAssetAttribute] = useState({
    field_name: "",
    field_type: "",
    field_value: "",
    display_name: "",
    required: false,
  });

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionAssetAttributeId, setActionAssetAttributeId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [errors, setErrors] = useState({});
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const [newAssetAttribute, setNewAssetAttribute] = useState({
    field_name: "",
    field_type: "",
    field_value: "",
    display_name: "",
    required: false,
  });



  const fetchAssetAttributes = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/paginate${queryString}`;

    try {
      const data = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      setAssetAttributes(data.assetAttributes || []);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
      setTotalItems(data.totalItems);
    } catch (error) {
      console.error("Error fetching asset attributes:", error.message);
      if (error.message === "Unauthorized") {
        navigate("/auth/login"); // Navigate to login if unauthorized
      }
      // Handle other errors as needed
    }
  };
  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
      // Add any additional logic for page change here
    }
  };

  // Calculate the page numbers to display

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  const handleAddAssetAttribute = async (e) => {
    e.preventDefault();
    // Ensure you have access to navigate function
    setLoading(true);
    setErrors({});

    try {
      // Prepare the field_value as an array if it contains commas
      const formattedFieldValue = newAssetAttribute.field_value.includes(",")
        ? newAssetAttribute.field_value.split(",").map((item) => item.trim())
        : newAssetAttribute.field_value;

      // // Construct the new asset attribute data
      // const newAttributeData = {
      //   field_name: newAssetAttribute.field_name,
      //   field_type: newAssetAttribute.field_type,
      //   field_value: formattedFieldValue,
      //   display_name: newAssetAttribute.display_name,
      //   required: newAssetAttribute.required,
      // };

      // Construct the new asset attribute data
      const newAttributeData = {
        ...newAssetAttribute,
        field_value: formattedFieldValue,
      };



      // Send the POST request to create the new asset attribute using fetchWrapper
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newAttributeData),
        },
        navigate // Include navigate for handling unauthorized errors
      );

      // Update the state with the new asset attribute
      setAssetAttributes([...assetAttributes, data]);
      setShowAddModal(false);
      setNewAssetAttribute({
        field_name: "",
        field_type: "",
        field_value: "",
        display_name: "",
        required: false,
      });
      toast.success("Asset Attribute Added Successful");
    } catch (error) {
      console.error("Error adding asset attribute:", error);
      if (error.response && error.response.errors) {
        setErrors(error.response.errors);
        toast.error(error.response.message || "Error adding asset attribute");
      } else {
        toast.error(error.message || "Error adding asset attribute");
      }
    } finally {
      setLoading(false);
      fetchAssetAttributes(); // Make sure this is properly defined and available
    }
  };

  const handleEditAssetAttribute = async (e) => {
    e.preventDefault();
    // Ensure you have access to navigate function
    setLoading(true);
    setErrors({});

    try {
      // Prepare the field_value as an array if it contains commas
      const formattedFieldValue = selectedAssetAttribute.field_value.includes(
        ","
      )
        ? selectedAssetAttribute.field_value
          .split(",")
          .map((item) => item.trim())
        : selectedAssetAttribute.field_value;

      const updatedAttributeData = {
        field_name: selectedAssetAttribute.field_name,
        field_type: selectedAssetAttribute.field_type,
        field_value: formattedFieldValue,
        display_name: selectedAssetAttribute.display_name,
        required: selectedAssetAttribute.required,
      };



      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/update/${selectedAssetAttribute._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedAttributeData),
        },
        navigate // Include navigate for handling unauthorized errors
      );

      const updatedAssetAttributes = assetAttributes.map((attribute) =>
        attribute._id === selectedAssetAttribute._id ? data : attribute
      );

      setAssetAttributes(updatedAssetAttributes);
      setShowEditModal(false);
      toast.success("Asset Attribute Updated Successfully");
    } catch (error) {
      console.error("Error updating asset attribute:", error);
      if (error.response && error.response.errors) {
        setErrors(error.response.errors);
        toast.error(error.response.message || "Error updating asset attribute");
      } else {
        toast.error(error.message || "Error updating asset attribute");
      }
    } finally {
      setLoading(false);
      fetchAssetAttributes(); // Make sure this is properly defined and available
    }
  };

  const handleToggleUserStatus = (assetAttributeId, currentStatus) => {
    setActionAssetAttributeId(assetAttributeId);
    setActionType(currentStatus ? "delete" : "restore");
    setConfirmModal(true);
  };
  const confirmAction = async () => {
    setLoading(true);
    try {
      // Determine the endpoint based on the action type
      const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/toggleSoftDelete/${actionAssetAttributeId}`;



      // Send a POST request to the server to perform the action on the asset attribute
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate, // Include navigate for handling unauthorized errors
        true // rawResponse to handle non-JSON response
      );

      setLoading(false);


      // Update the status of the asset attribute
      const updatedAssetAttributes = assetAttributes.map((attribute) =>
        attribute._id === actionAssetAttributeId
          ? { ...attribute, status: actionType === "restore" ? true : false }
          : attribute
      );
      setAssetAttributes(updatedAssetAttributes); // Update the asset attributes state
      setConfirmModal(false);

      if (actionType === "delete") {
        toast.success(`Asset Attribute Inactive Successful`);
      } else {
        toast.success(`Asset Attribute Restore Successful`);
      }
    } catch (error) {
      setLoading(false);
      console.error(`Error ${actionType} asset attribute:`, error);
      toast.error(`Error ${actionType} asset attribute`);
    }
  };
  const handleBulkDelete = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/toggleSoftDelete/${checkedItems[0]}`;

    const requestData = {
      ids: checkedItems,
    };



    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        },
        navigate, // Include navigate for handling unauthorized errors
        true // rawResponse to handle non-JSON response
      );


      setCheckedItems([]);

      const updatedAssetAttributes = assetAttributes.map((attribute) =>
        checkedItems.includes(attribute._id)
          ? { ...attribute, status: false }
          : attribute
      );

      setAssetAttributes(updatedAssetAttributes);
      setBulkDeleteModal(false);
      toast.success("All the selected items are Inactived");
    } catch (error) {
      console.error("Error deleting selected asset attributes:", error);
      toast.error("Error deleting selected asset attributes");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        assetAttributes
          .filter((assetAttribute) => assetAttribute.status)
          .map((assetAttribute) => assetAttribute._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (assetAttributeId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(assetAttributeId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== assetAttributeId)
        : [...prevCheckedItems, assetAttributeId];

      setAllChecked(
        updatedCheckedItems.length ===
        assetAttributes.filter((assetAttribute) => assetAttribute.status)
          .length
      );
      return updatedCheckedItems;
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchAssetAttributes(); // Perform search
    }
  };

  useEffect(() => {
    fetchAssetAttributes();
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    assetAttributes.length,
    showEditModal,
    statusFilter,
  ]);

  return (
    <>
      <div className="">
        <div className="container ">
          <div className="show-breadcrumb pt-3">
            <div className="">
              <h5 className="">Asset Attribute</h5>

              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb ">
                  <li className="breadcrumb-item ">
                    <a className="">Assets</a>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Asset Attribute
                  </li>
                </ol>
              </nav>

              <div
                className="navbar-3 d-flex justify-content-between"
                style={{ marginTop: "-3px" }}
              >
                <div className="d-flex gap-3">
                  <div className="search-container ">
                    <img src={search2} alt="Search" />
                    <input
                      type="text"
                      className=""
                      id="search"
                      value={search}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Search"
                      name="search"
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    {checkedItems.length > 0 && (
                      <button
                        id="bulkDelete"
                        className="bulkDelete-btn"
                        style={{ display: "block" }}
                        onClick={() => setBulkDeleteModal(true)}
                      >
                        <span>
                          <img
                            src={recyclebin}
                            height="24px"
                            width="24px"
                            alt=""
                          />
                        </span>{" "}
                        Inactive
                      </button>
                    )}
                  </div>
                </div>

                <div className="d-flex gap-3">
                  <div className="dropdown">
                    <select
                      id="cars"
                      className=" select-unit textarea "
                      value={statusFilter}
                      onChange={(e) => handleStatusChange(e.target.value)}
                      style={{
                        width: "120px",
                        height: "calc(100% - 1px)", // Adjust height to be 3px less
                      }}
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  {hasPermission(["assets.create"]) && (
                    <div>
                      <button
                        type="button"
                        id="openPopup"
                        className="btn-bg"
                        onClick={() => {
                          setErrors({});
                          setShowAddModal(true);
                        }}
                      // onClick={() => setShowAddModal(true)}
                      >
                        <span className="plus-icon">
                          <img src={plus1} alt="Plus Icon" />
                        </span>
                        ADD ASSET ATTRIBUTE
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginTop: "-10px" }}>
                <div className="table-responsive">
                  <table className="table  align-middle table-text">
                    <thead className="table-head align-middle">
                      <tr>
                        <th className="table-check">
                          <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleHeaderCheckboxChange}
                          />
                        </th>
                        <th>ID</th>

                        <th
                          className=" text-uppercase"
                          onClick={() => handleSortChange("field_name")}
                        >
                          Field Name{" "}
                          {sortBy.field === "field_name" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>

                        <th
                          className=" text-uppercase"
                          onClick={() => handleSortChange("field_type")}
                        >
                          Field Type{" "}
                          {sortBy.field === "field_type" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th
                          className=" text-uppercase"
                          onClick={() => handleSortChange("field_value")}
                        >
                          Field Value{" "}
                          {sortBy.field === "field_value" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th
                          className=" text-uppercase"
                          onClick={() => handleSortChange("display_name")}
                        >
                          Display Name{" "}
                          {sortBy.field === "display_name" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th
                          className=" text-uppercase"
                          onClick={() => handleSortChange("required")}
                        >
                          Is Required{" "}
                          {sortBy.field === "required" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>

                        <th className=" text-uppercase">STATUS</th>
                        {(hasPermission(["assets.update"]) ||
                          hasPermission(["assets.delete"])) && (
                            <th className="col-2 text-uppercase">ACTION</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {assetAttributes.map((assetAttribute, id1) => (
                        <tr
                          key={assetAttribute._id}
                          className={
                            assetAttribute.status ? "" : "disabled text-muted"
                          }
                        >
                          <td className="table-check">
                            <input
                              type="checkbox"
                              checked={checkedItems.includes(
                                assetAttribute._id
                              )}
                              onChange={() =>
                                handleRowCheckboxChange(assetAttribute._id)
                              }
                              disabled={!assetAttribute.status}
                            />
                          </td>
                          <td>{id1 + startIndex}</td>
                          <td>{assetAttribute.field_name}</td>

                          <td>{assetAttribute.field_type}</td>
                          <td>{assetAttribute.field_value}</td>
                          <td>{assetAttribute.display_name}</td>
                          <td>{assetAttribute.required ? "Yes" : "No"}</td>
                          <td>
                            {assetAttribute.status ? (
                              <span className="active-status">Active</span>
                            ) : (
                              <span className="inactive">Inactive</span>
                            )}
                          </td>

                          {(hasPermission(["assets.update"]) ||
                            hasPermission(["assets.delete"])) && (
                              <td>
                                <div className="action-icons d-flex justify-content-left align-items-center ">
                                  {hasPermission(["assets.update"]) &&
                                    assetAttribute.status && (
                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                        }}
                                        className="align-content-center me-3"
                                        onClick={() => {
                                          setErrors({});
                                          setSelectedAssetAttribute(
                                            assetAttribute
                                          );
                                          setShowEditModal(true);
                                        }}
                                        disabled={!assetAttribute.status}
                                      >
                                        <img src={edit} alt="edit" />
                                      </button>
                                    )}

                                  {hasPermission(["assets.delete"]) && (
                                    <span className="align-content-center switcher">
                                      <label className="switch switch1">
                                        <input
                                          type="checkbox"
                                          checked={assetAttribute.status}
                                          onChange={() =>
                                            handleToggleUserStatus(
                                              assetAttribute._id,
                                              assetAttribute.status
                                            )
                                          }
                                        />
                                        <span className="slider slider1 round"></span>
                                      </label>
                                    </span>
                                  )}
                                </div>
                              </td>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                totalItems={totalItems}
                startIndex={startIndex}
                endIndex={endIndex}
              />
            </div>
          </div>
        </div>
        {/* Add Asset Attribute Modal */}
        <div
          id="overlay"
          className={`modal fade ${showAddModal ? "show" : ""}`}
          tabIndex="-1"
          assetAttribute="dialog"
          style={{
            zIndex: 30,
            display: showAddModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Add Asset Attribute</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setShowAddModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form
                  onSubmit={handleAddAssetAttribute}
                  autoComplete="off"
                  noValidate
                  className="needs-validation"
                >
                  <div className="addunit-form">
                    <div className="row mb-4">
                      <div className="col">
                        <div className="d-flex flex-column ">
                          <label
                            htmlFor="fieldName"
                            className="addunit-form-text"
                          >
                            Field Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.field_name ? "is-invalid" : ""
                              }`}
                            id="fieldName"
                            placeholder="Enter the Field Name"
                            value={newAssetAttribute.field_name}
                            onChange={(e) =>
                              setNewAssetAttribute({
                                ...newAssetAttribute,
                                field_name: e.target.value,
                              })
                            }
                          />
                          {errors.field_name && (
                            <div className="invalid-feedback">
                              {errors.field_name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="  col ">
                        <div className="d-flex flex-column ">
                          <label
                            htmlFor="fieldType"
                            className="addunit-form-text"
                          >
                            Field Type <span className="text-danger"> *</span>
                          </label>
                          <select
                            className={`form-select select-unit textarea  ${errors.field_type ? "is-invalid" : ""
                              }`}
                            id="fieldType"
                            value={newAssetAttribute.field_type}
                            onChange={(e) =>
                              setNewAssetAttribute({
                                ...newAssetAttribute,
                                field_type: e.target.value,
                              })
                            }
                          >
                            <option disabled value="">
                              Select
                            </option>
                            <option value="string">String</option>
                            <option value="number">Number</option>
                            <option value="select">Select</option>
                            <option value="date">Date</option>
                            <option value="textarea">Textarea</option>
                            {/* <option value="file">File</option> */}
                          </select>
                          {errors.field_type && (
                            <div className="invalid-feedback">
                              {errors.field_type}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="d-flex flex-column mb-4">
                          <label
                            htmlFor="fieldValue"
                            className="addunit-form-text"
                          >
                            Field Value{" "}
                            {newAssetAttribute.field_type === "select" && (
                              <span className="text-danger"> *</span>
                            )}
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.field_value ? "is-invalid" : ""
                              }`}
                            id="fieldValue"
                            placeholder={
                              newAssetAttribute.field_type === "select"
                                ? "Enter the Field Value"
                                : "Field Value is disabled"
                            }
                            value={newAssetAttribute.field_value}
                            onChange={(e) =>
                              setNewAssetAttribute({
                                ...newAssetAttribute,
                                field_value: e.target.value,
                              })
                            }
                            disabled={newAssetAttribute.field_type !== "select"}
                          />
                          {errors.field_value && (
                            <div className="invalid-feedback">
                              {errors.field_value}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-6 ">
                        <div className="d-flex flex-column mb-4">
                          <label
                            htmlFor="displayName"
                            className="addunit-form-text"
                          >
                            Display Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.display_name ? "is-invalid" : ""
                              }`}
                            id="displayName"
                            placeholder="Enter the Display Name"
                            value={newAssetAttribute.display_name}
                            onChange={(e) =>
                              setNewAssetAttribute({
                                ...newAssetAttribute,
                                display_name: e.target.value,
                              })
                            }
                          />
                          {errors.display_name && (
                            <div className="invalid-feedback">
                              {errors.display_name}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="d-flex flex-column mb-4">
                        <label htmlFor="required" className="addunit-form-text">
                          Required <span className="text-danger"> *</span>
                        </label>
                        <select
                          className={`form-select select-unit textarea  ${errors.required ? "is-invalid" : ""
                            }`}
                          id="required"
                          value={newAssetAttribute.required}
                          onChange={(e) =>
                            setNewAssetAttribute({
                              ...newAssetAttribute,
                              required: e.target.value,
                            })
                          }
                        >
                          <option disabled value="">
                            Select
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setShowAddModal(false)}
                    >
                      Close
                    </button>
                    <button type="submit" className="update-btn">
                      Add
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>

        {/* Edit Role Modal */}
        <div
          id="overlay"
          className={`modal fade ${showEditModal ? "show" : ""}`}
          tabIndex="-1"
          assetAttribute="dialog"
          style={{
            zIndex: 30,
            display: showEditModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Edit Asset Attribute</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setShowEditModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form
                  onSubmit={handleEditAssetAttribute}
                  autoComplete="off"
                  noValidate
                  className="needs-validation"
                >
                  {selectedAssetAttribute && (
                    <div className="addunit-form">
                      <div className="row mb-4">
                        <div className="col-6">
                          <div className="d-flex flex-column ">
                            <label
                              htmlFor="fieldName"
                              className="addunit-form-text"
                            >
                              Field Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${errors.field_name ? "is-invalid" : ""
                                }`}
                              id="fieldName"
                              placeholder="Enter the Field Name"
                              value={selectedAssetAttribute.field_name}
                              onChange={(e) =>
                                setSelectedAssetAttribute({
                                  ...selectedAssetAttribute,
                                  field_name: e.target.value,
                                })
                              }
                            />
                            {errors.field_name && (
                              <div className="invalid-feedback">
                                {errors.field_name}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="fieldType"
                              className="addunit-form-text"
                            >
                              Field Type <span className="text-danger"> *</span>
                            </label>
                            <select
                              className={`form-select select-unit textarea  ${errors.field_type ? "is-invalid" : ""
                                }`}
                              id="fieldType"
                              value={selectedAssetAttribute.field_type}
                              onChange={(e) =>
                                setSelectedAssetAttribute({
                                  ...selectedAssetAttribute,
                                  field_type: e.target.value,
                                })
                              }
                            >
                              <option disabled value="">
                                Select
                              </option>
                              <option value="string">String</option>
                              <option value="number">Number</option>
                              <option value="select">Select</option>
                              <option value="date">Date</option>
                              <option value="textarea">Textarea</option>
                              {/* <option value="file">File</option> */}
                            </select>
                            {errors.field_type && (
                              <div className="invalid-feedback">
                                {errors.field_type}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-6">
                          <div className="d-flex flex-column ">
                            <label
                              htmlFor="fieldValue"
                              className="addunit-form-text"
                            >
                              Field Value{" "}
                              {selectedAssetAttribute.field_type ===
                                "select" && (
                                  <span className="text-danger"> *</span>
                                )}
                            </label>
                            <input
                              type="text"
                              className={`form-control ${errors.field_value ? "is-invalid" : ""
                                }`}
                              id="fieldValue"
                              placeholder={
                                selectedAssetAttribute.field_type === "select"
                                  ? "Enter the Field Value"
                                  : "Field Value is disabled"
                              }
                              value={selectedAssetAttribute.field_value}
                              onChange={(e) =>
                                setSelectedAssetAttribute({
                                  ...selectedAssetAttribute,
                                  field_value: e.target.value,
                                })
                              }
                              disabled={
                                selectedAssetAttribute.field_type !== "select"
                              }
                            />
                            {errors.field_value && (
                              <div className="invalid-feedback">
                                {errors.field_value}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="displayName"
                              className="addunit-form-text"
                            >
                              Display Name{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${errors.display_name ? "is-invalid" : ""
                                }`}
                              id="displayName"
                              placeholder="Enter the Display Name"
                              value={selectedAssetAttribute.display_name}
                              onChange={(e) =>
                                setSelectedAssetAttribute({
                                  ...selectedAssetAttribute,
                                  display_name: e.target.value,
                                })
                              }
                            />
                            {errors.display_name && (
                              <div className="invalid-feedback">
                                {errors.display_name}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="d-flex flex-column mb-4">
                          <label
                            htmlFor="required"
                            className="addunit-form-text"
                          >
                            Required <span className="text-danger"> *</span>
                          </label>
                          <select
                            className={`form-select select-unit textarea  ${errors.required ? "is-invalid" : ""
                              }`}
                            id="required"
                            value={selectedAssetAttribute.required}
                            onChange={(e) =>
                              setSelectedAssetAttribute({
                                ...selectedAssetAttribute,
                                required: e.target.value,
                              })
                            }
                          >
                            <option disabled value="">
                              Select
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="addunit-card-footer ">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      Close
                    </button>
                    <button type="submit" className="update-btn">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>

        {/* Confirmation Modal */}
        <div
          id="overlay"
          className={`modal fade ${confirmModal ? "show" : ""}`}
          tabIndex="-1"
          assetAttribute="dialog"
          style={{
            zIndex: 30,
            display: confirmModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>
                    {actionType === "restore" ? "Restore" : "Inactive"} Asset
                    Attribute
                  </h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setConfirmModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div className="addunit-form">
                  <p>
                    Are you sure you want to{" "}
                    {actionType === "restore" ? "restore" : "inactive"} this
                    asset attribute?
                  </p>
                </div>
                <div className="addunit-card-footer justify-content-between">
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setConfirmModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="update-btn"
                    onClick={confirmAction}
                  >
                    {actionType === "restore" ? "Restore" : "Inactive"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bulk Delete Modal */}
        <div
          id="overlay"
          className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
          tabIndex="-1"
          assetAttribute="dialog"
          style={{
            zIndex: 30,
            display: bulkDeleteModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Bulk Inactive</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setBulkDeleteModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div className="bulk-delete-unit">
                  <img src={recyclebin} width="48px" height="48px" />

                  <h4 className="delete-unit-h4"> Inactive Asset Attributes</h4>
                  <p className="delete-unit-text">
                    Are you sure you want to inactive all the selected
                    attributes?
                  </p>
                </div>
                <div className="addunit-card-footer justify-content-between">
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setBulkDeleteModal(false)}
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    className="update-btn"
                    onClick={handleBulkDelete}
                  >
                    CONFIRM
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default AssetAttribute;
